import { ChevronRight } from "lucide-react"
import { memo, useCallback } from "react"
import { setPreviewModal } from "../../../../../redux/slices/integrations"
import { Integration } from "../../../../../types"
import { useAppDispatch } from "../../../../hooks"
import IntegrationViewsStatusTag from "../components/IntegrationViewsStatusTag"

interface Props {
  data: Integration
  onSelect?: (id: string) => void
}

const IntegrationCell = memo(({ data, onSelect }: Props) => {
  const dispatch = useAppDispatch()
  const { title, type, app_key, id } = data

  const openEditPanel = useCallback(() => {
    onSelect?.(id)
  }, [onSelect, id])

  const handlePreviewClick = useCallback(() => {
    dispatch(
      setPreviewModal({
        isOpen: true,
        app_key,
        title
      })
    )
  }, [dispatch, app_key, title])

  return (
    <td className="whitespace-nowrap py-4 pl-2 pr-3">
      <div className="flex">
        <div
          className="pl-4"
          onClick={openEditPanel}
          tabIndex={0}
          role="button"
        >
          <strong className="text-base flex items-center">
            <span className="hover:underline">{title} </span>
            <IntegrationViewsStatusTag integrationId={id} className="ml-2" />
          </strong>
          <span className="text-sm text-neutral-400">{type}</span>
        </div>
        {type !== "api" && (
          <button
            onClick={handlePreviewClick}
            type="button"
            className="group appearance-none cursor-pointer ml-auto flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300 rounded"
          >
            <span className="hidden transition-colors text-base border-dashed border-neutral-400 border-b lg:inline-block mr-6 ml-3 group-hover:text-primary-400">
              Desktop/Mobile preview
            </span>
            <span className="transition-colors text-base border-dashed border-neutral-400 border-b inline-block lg:hidden mr-6 ml-3 group-hover:text-primary-400">
              Preview
            </span>
            <ChevronRight className="text-neutral-400" size={24} />
          </button>
        )}
      </div>
    </td>
  )
})

IntegrationCell.displayName = "IntegrationCell"

export default IntegrationCell
